<!-- UNIVAPLAT-2772: deactivate license / edit deactivation reason modal -->
<div class="modal-dialog modal-dialog-centered admin-modal">
    <div class="modal-content">
        <form [formGroup]="form" (ngSubmit)="submit()">
            <div class="modal-header">
                <h1 class="modal-title fs-5" data-testid="license-modal-title">
                    <i class="bi me-1" [class.bi-person-x]="mode === 'deactivate'" [class.bi-pencil-square]="mode === 'editReason'"></i>
                    {{ mode === 'deactivate' ? 'Deactivate license' : 'Edit deactivation reason' }}
                </h1>
            </div>
            <div class="modal-body">
                <p class="mb-3" *ngIf="userName">
                    User: <strong data-testid="license-modal-user-name">{{ userName }}</strong>
                </p>

                <!-- editReason mode with no deactivated period in the history: nothing to edit -->
                <div class="alert alert-warning mb-0" *ngIf="historyMissing" data-testid="license-modal-history-missing">
                    No deactivated license found for this user.
                </div>

                <fieldset class="form-group" *ngIf="!historyMissing">
                    <label class="form-label" for="license-deactivation-reason">
                        Reason{{ mode === 'deactivate' ? ' (optional)' : '' }}
                    </label>
                    <textarea id="license-deactivation-reason"
                              class="form-control"
                              rows="3"
                              formControlName="reason"
                              data-testid="license-modal-reason"
                              [class.is-invalid]="form.controls.reason.touched && form.controls.reason.invalid"></textarea>
                    <div class="d-flex justify-content-between">
                        <div>
                            <div class="invalid-feedback d-block"
                                 *ngIf="form.controls.reason.touched && form.controls.reason.errors?.['required']"
                                 data-testid="license-modal-reason-required-error">
                                A reason is required.
                            </div>
                            <div class="invalid-feedback d-block"
                                 *ngIf="form.controls.reason.errors?.['maxlength']"
                                 data-testid="license-modal-reason-maxlength-error">
                                The reason must be {{ maxLength }} characters or fewer.
                            </div>
                        </div>
                        <small class="text-muted" data-testid="license-modal-reason-counter">
                            {{ form.controls.reason.value?.length || 0 }}/{{ maxLength }}
                        </small>
                    </div>
                </fieldset>
            </div>
            <div class="modal-footer">
                <button type="submit" class="btn btn-success"
                        [disabled]="saving || loading || historyMissing"
                        data-testid="license-modal-submit">
                    {{ mode === 'deactivate' ? 'Deactivate' : 'Save reason' }}
                </button>
                <button type="button" class="btn btn-outline-dark" (click)="modal.close(false)"
                        data-testid="license-modal-close">Close</button>
            </div>
        </form>
    </div>
</div>
<spinner *ngIf="loading"></spinner>
